import {
  FieldBuilder,
  FieldDefinition,
  MenuCategories,
  MenuSubcategories,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
} from '@zendra/shared';
import { RotationProjectionPlanningOrchestratorService } from 'orchestrator';
import { RegionService, StandService, TreeObservationService } from 'cbd-proxies';
import { TreeDataInformationPropertyOptionsService } from './tree-data-information-orchestrator.service';

FieldBuilder.setNamespace('Inventory');

export const TREEDATAINFORMATION_PRE_ACCESS_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('regionId', 'Entity.TreeDataInformation.Region', RegionService)
    .prefilter({ order: 1, multiple: true })
    .hideByDefault()
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'propertyId',
    'Entity.TreeDataInformation.Property',
    TreeDataInformationPropertyOptionsService,
  )
    .prefilter({ order: 2, dependsOn: ['regionId'], multiple: true })
    .hideByDefault()
    .readOnly()
    .build(),
  FieldBuilder.foreignKey('standLocationIdFilter', 'Entity.TreeDataInformation.Stand', StandService)
    .keyField('locationId')
    .prefilter({
      order: 3,
      dependsOn: ['regionId', 'propertyId'],
      queryKey: 'standLocationId',
      multiple: true,
    })
    .hideByDefault()
    .readOnly()
    .build(),
  FieldBuilder.number('inventoryYear', 'Entity.TreeDataInformation.Year')
    .prefilter({ order: 4, queryKey: 'inventoryYear', defaultMode: 'range' })
    .hideByDefault()
    .readOnly()
    .build(),
];

export const TREEDATAINFORMATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('treeDataInformationId', 'Entity.TreeDataInformation.TreeDataInformationId')
    .build(),
  FieldBuilder.foreignKey(
    'rotationId',
    'Entity.Stand',
    RotationProjectionPlanningOrchestratorService
  )
    .required()
    .display('rotationDisplay')
    .displayFromNested('standNameCycleRotation')
    .sortBy('standNameCycleRotation')
    .build(),
  FieldBuilder
    .number('cycleId', 'Entity.Cycle.CycleId')
    .build(),
  FieldBuilder
    .number('standLocationId', 'Entity.TreeDataInformation.StandLocationId')
    .build(),
  FieldBuilder
    .text('standName', 'Entity.Stand')
    .build(),
  FieldBuilder
    .text('standNameCycleRotation', 'Entity.StandNameCycleRotation')
    .build(),
  FieldBuilder
    .number('propertyLocationId', 'Entity.TreeDataInformation.PropertyLocationId')
    .build(),
  FieldBuilder
    .text('propertyLocationName', 'Entity.Property')
    .build(),
  FieldBuilder
    .number('treeNumber', 'Entity.TreeDataInformation.TreeNumber')
    .build(),
  FieldBuilder
    .number('treeAge', 'Entity.TreeDataInformation.TreeAge')
    .decimal()
    .build(),
  FieldBuilder
    .text('species', 'Entity.TreeDataInformation.Species')
    .build(),
  FieldBuilder
    .number('area', 'Entity.TreeDataInformation.Area')
    .decimal()
    .build(),
  FieldBuilder
    .date('inventoryDate', 'Entity.TreeDataInformation.InventoryDate')
    .build(),
  FieldBuilder
    .number('realHeight', 'Entity.TreeDataInformation.RealHeight')
    .decimal()
    .build(),
  FieldBuilder
    .number('estimatedHeight', 'Entity.TreeDataInformation.EstimatedHeight')
    .decimal()
    .build(),
  FieldBuilder
    .number('averageHeightDiameter', 'Entity.TreeDataInformation.AverageHeightDiameter')
    .decimal()
    .build(),
  FieldBuilder
    .number('basalArea', 'Entity.TreeDataInformation.BasalArea')
    .decimal()
    .build(),
  FieldBuilder
    .number('plotNumber', 'Entity.TreeDataInformation.PlotNumber')
    .build(),
  FieldBuilder
    .number('individualVolume', 'Entity.TreeDataInformation.IndividualVolume')
    .decimal()
    .build(),
  FieldBuilder
    .number('measurementOrderNumber', 'Entity.TreeDataInformation.MeasurementOrderNumber')
    .build(),
  FieldBuilder
    .number('radius', 'Entity.TreeDataInformation.Radius')
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'treeObservationId',
    'Entity.TreeDataInformation.TreeObservationId',
    TreeObservationService,
  )
    .display('name')
    .displayFromNested('treeObservationName')
    .sortBy('treeObservationName')
    .readOnly()
    .build(),
  FieldBuilder
    .datetime('creationTime', 'Entity.TreeDataInformation.CreationDate')
    .build(),
  FieldBuilder
    .datetime('lastModificationTime', 'Entity.TreeDataInformation.LastModificationDate')
    .build(),
  FieldBuilder
    .text('lastModificationBy', 'Entity.TreeDataInformation.LastModificationBy')
    .build(),
];

export const TREEDATAINFORMATION_CONFIG = {
  entityName: 'TreeDataInformation',
  localizationKey: 'Inventory::Entity.TreeDataInformation',
  fields: TREEDATAINFORMATION_FIELDS,
  permission: 'PlanningInventory.TreeDataInformations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Inventory + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.QueriesInventory + MENU_NAME_SUFFIX,
};
